<div class="usan-form-item salt-ester-chemdraw-file-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasAdditionalDocumentation ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column">
      <span class="usan-form-item salt-ester-chemdraw-file-item salt-ester-chemdraw-file-text" *ngIf="!isFormDType">
        Additional information to support the choice of stem and document action of the compound (recommended)
        <ul>
          <li>Pharmacokinetic data/binding constants showing strength of binding with intended target(s)</li>
          <li>Nonclinical pharmacology section or executive summary of the investigator&amp;s brochure</li>
          <li>Publications related to the substance to be named</li>
        </ul>
      </span>
      <span class="usan-form-item salt-ester-chemdraw-file-item salt-ester-chemdraw-file-text" *ngIf="isFormDType">
        Additional information to support the revision(s) to the statement of adoption (recommended)
      </span>
    </div>
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-salt-ester-chemdraw-file form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload any additional documentation
    </button>
  </div>
  <ng-container *ngIf="hasAdditionalDocumentation">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>